import React, { useState } from "react";
import { FlexibleContainer } from "../../components/containers/styledComponents";
import { Icon, IconContainer } from "../../components/visuals/styledComponents";
import { compassLightRed, compassLightGreyBackground } from "../../styles";
import Trashcan from "../../assets/svg/trashcan.svg";
import TrashcanGrey from "../../assets/svg/trashcan_grey.svg";

export interface DeleteItemProps {
  id: string | number;
  isDeletable: boolean;
  onDelete?: (id: string | number) => void;
}

export const DeleteItem = ({
  id,
  isDeletable,
  onDelete,
}: DeleteItemProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = (): void => {
    setIsHovered(true);
  };

  const handleMouseLeave = (): void => {
    setIsHovered(false);
  };

  const handleDelete = (): void => {
    onDelete && onDelete(id);
  };

  return (
    <>
      {isDeletable && (
        <FlexibleContainer
          ml={"10px"}
          jc="flex-start"
          c="pointer"
          onClick={handleDelete}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <IconContainer
            bg={isHovered ? compassLightRed : compassLightGreyBackground}
            style={{ transform: isHovered ? "scale(1.2)" : "scale(1)" }}
          >
            <Icon src={isHovered ? Trashcan : TrashcanGrey} />
          </IconContainer>
        </FlexibleContainer>
      )}
    </>
  );
};
